// extracted by mini-css-extract-plugin
export var container = "_8e-0";
export var fallback = "_8e-5";
export var fallbackIcon = "_8e-6";
export var hidden = "_8e-2";
export var image = "_8e-3";
export var loaded = "_8e-4";
export var placeholder = "_8e-1";